module.exports = __webpack_public_path__ + "static/bottles-a01813d19e02cb899e3b7dc8bc5de36f.png";